import { render, staticRenderFns } from "./distributor.vue?vue&type=template&id=572d93c8&scoped=true&v-loading=lzLoading&element-loading-text=%E5%8A%A0%E8%BD%BD%E4%B8%AD..."
import script from "./distributor.vue?vue&type=script&lang=js"
export * from "./distributor.vue?vue&type=script&lang=js"
import style0 from "./distributor.vue?vue&type=style&index=0&id=572d93c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d93c8",
  null
  
)

export default component.exports